import $ from 'jquery'
import AddDemandeAnalyse from '@/views/consultations/traitement-en-cours/analyses/add-analyse'

export default {
    name: 'analyses',
    components: {
        AddDemandeAnalyse
    },
    props: [
        "consultation_id", "protocole_id", "demande_analyses", "hn", 
        "etat_traitement", "p_soignant", "active_role", "jn", "can_show_empty"
    ],
    data() {
        return {
            is_loading: true,
            is_empty: false,
            resultat_analyse: {},

            asset_url: '',
            can_view: false,
            to_be_deleted: {},
            del_loading: false,
            is_confirm: false,

            is_new_bulletin: 0,
            edit_bulletin: {
                bulletin_id: 0,
                ref_bon: '',
                renseignement_clinique: '',
                analyses: []
            }
        }
    },

    watch: {
        demande_analyses() {
            this.getDemandeAnalyses()
        }  
    },

    computed: {
        /**
         * User Info
         * @returns
         */
         userCredentials() {
            return this.$store.getters['authInfo'];
        },
    },

    mounted() {
        this.asset_url = this.assets_path + '/files'

        this.getDemandeAnalyses()
    },

    methods: {
        demandeBulletin(v) {
            this.is_new_bulletin = v
        },

        editBulletin(b) {
            this.edit_bulletin = {
                bulletin_id: b.bulletin_id,
                ref_bon: b.ref_bon,
                renseignement_clinique: b.renseignement_clinique,
                analyses: b.analyses
            }

            let data = {
                protocole_id: this.protocole_id,
                edit_bulletin: this.edit_bulletin 
            }
            this.$emit("emitBulletinProtocoleAnalyse", data)
            console.log(this.edit_bulletin)
        },

        getDemandeAnalyses() {
            this.is_loading = true
            if (this.demande_analyses.length > 0) {
                this.is_empty = false
            } else {
                this.is_empty = true
            }
            setTimeout(() => {
               this.is_loading = false 
            }, 500);
        },

        /**
         * View result
         */
        viewResult(demande_analyse) {
            this.resultat_analyse = {
                id: demande_analyse.analyse.id,
                resultat: demande_analyse.resultat_fichier,
                analyse: demande_analyse.analyse.nom,
                est_disponible: (demande_analyse.resultat_fichier != null)?true:false
            }
            console.log(this.resultat_analyse)
        },

        deleteAnalyse(anl) {
            
            this.to_be_deleted = {
                id: anl.analyse.id,
                analyse: anl.analyse.nom
            }
        },

         /**
         * Cache le message d'erreur au click du checkbox
         */
        onConfirm() {
            $('.err-msg').fadeOut(500);
        },

        confirmer() {
            this.is_confirm = true
        },

        supprimer(selector) {
            this.del_loading = true;

            let confirm = document.getElementById(selector);
            
            if (confirm.checked == false) { //  Vérifie si l'utilisateur a confirmé la cloture
                $('.err-msg').fadeIn(500)
                this.del_loading = false
                return
            }
            let data = {
                consultation_id: this.consultation_id,
                protocole_id: this.protocole_id,
                analyse_id: this.to_be_deleted.id
            }

            console.log(data)
            this.$store.dispatch('deleteDemandeAnalyseForHn', data).then((response) => {
                if (response > 0) {
                    this.successToast("Analyse supprimée avec succès")
                    this.$emit('emitProtocole', this.jn)

                    this.is_confirm = false
                    this.$refs.analyseDelModal.click();
                }
                this.del_loading = false
            }).catch((err) => {
                console.log("ERROR CATCH: ", err)
                this.del_loading = false
            })
        },
    }
}


